export const FACEBOOK_PAGE_SCOPES = [
  'pages_manage_metadata',
  'pages_messaging',
  'pages_show_list',
];

export const INSTAGRAM_SCOPES = [];

export const buildFacebookLoginScopes = () => {
  return FACEBOOK_PAGE_SCOPES.join(',');
};
